import { listItemButtonClasses } from '@mui/material';
import color from '../../utils/color';

export function listItemButton() {
  const mainColor = '#B3E5CF';
  const hoverColor = color.light(mainColor);
  return {
    MuiListItemButton: {
      styleOverrides: {
        root: {
          '&:hover': {
            background: hoverColor,
          },
          [`&.${listItemButtonClasses.selected}`]: {
            background: mainColor,

            '&:hover': {
              background: mainColor,
            },
          },
        },
      },
    },
  };
}
